import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import { Helmet } from "react-helmet";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import Fetch, { Loader, Get, priceFormat } from "../inc/Fetch";
import { Config } from '../../inc/Config';
import { Img } from "../components/Elements";
import Product from "../components/product/Product";
import ErrorPage from "./ErrorPage";

import { GoSquareFill } from "react-icons/go";
import { MdArrowForwardIos, MdOutlineFilterList, MdOutlineClose } from "react-icons/md";

import ListCats from "../components/listCats";
import Header from "./Header";
import Footer from "./Footer";
import Cats from "../components/product/Cats";
// ads

import './css/Cats.css'

export default function Cat({ sortBy }) {
    
    const { t } = useTranslation();
    const params = useParams();

    let page = useRef(1);
    let scrollAllow = useRef(true);
    
	const {siteData} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;

    
    const [price, setprice] = useState([0, 10000]);
    const [filter, setfilter] = useState({});
    const [sort, setsort] = useState(sortBy?.val || 'date');
    
    let idRef = useRef(params?.id);
    let filterRef = useRef(filter);
    let sortRef = useRef(filter);
    
    //siteInfo?.settings?.sort?.val
    const [maxPrice, setmaxPrice] = useState(10000);
    const [openFilter, setopenFilter] = useState(false);
    const [data, setdata] = useState({});
    const [products, setproducts] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    const [isFetching, setisFetching] = useState(false);
    

    const handleChange = (newValue) => {
        setprice(newValue?.target?.value );
    };
    

    function sortLoad(val) {
        setsort(val);
        sortRef.current = val;
        
        loadData();
    }


    function dynamicFilter(v, k) {

        setfilter(p => ({
            ...p, 
            [k]:v
        }));
        
    }
    

    async function loadMore() {
        
        setisFetching(true);
        let res = await Fetch('cats', { _id: idRef.current, filter:filterRef.current, sort:sortRef.current, page:page.current });
        
        setproducts(p => [...p, ...res?.products]);
        
        page.current = page?.current + 1; 

        setisFetching(false);
        if (res?.products?.length) {
            setTimeout(() => {
                scrollAllow.current = true;
            }, 1000);
        }
    }

    async function loadData() {
        
        scrollAllow.current = true;
        page.current = 1; 
        setisLoading(true);
        let res = await Fetch('cats', { _id: params?.id, filter:filter, sort:sortRef.current });
        setdata(res);
        setproducts(res?.products);
        setisLoading(false);
        setisFetching(false);
        
    }
    
    // const { data, error, isLoading, refetch, isFetching } = useQuery(`cat-${params?.id}`, loadData); 

    useEffect(() => {

        if (data?.filter?.maxPrice) {
            setmaxPrice(data?.filter?.maxPrice);

            let filt = [0, data?.filter?.maxPrice];

            setprice(filt);
        }

    }, [data?.filter]);

    useEffect(() => {

        filterRef.current = filter;
        if (Object.keys(filter)?.length) {
            loadData();
        }
      
    }, [filter]);

    useEffect(() => {
        idRef.current = params?.id;
        sortRef.current = sort;

        if (sort) {
            let getEl = document.getElementById("mainBodyData");
            getEl.scrollTo(0, 0);
            loadData();
        }
            
      
    }, [params?.id]);


    const handleScroll = (e) => {

        if (siteInfo?.settings?.paging?.val) {
            return false;
        }

        let vals = {};
        vals.scrollTop = e?.target?.scrollTop;
        vals.scrollHeight = e?.target?.scrollHeight;
        vals.clientHeight = e?.target?.clientHeight;

        if (window?.innerWidth < 700) {

            let getEl = document.querySelector("footer");

            vals.scrollTop = window.scrollY;
            vals.scrollHeight = getEl?.getBoundingClientRect().top + window.scrollY;
            vals.clientHeight = window.outerHeight;
        }

        if (scrollAllow.current) {
            let trig = vals.scrollHeight - vals.clientHeight - vals.scrollTop - 400;
            
            if (trig <= 0) {
                console.log("sssss");
                
                loadMore();
                scrollAllow.current = false;
                
            }
        }
        
    }

    
    useEffect(() => {

        
        let getEl = document.getElementById("mainBodyData");
        if (getEl?.clientWidth < 700) {
            getEl = window;
        }
        setTimeout(() => {
            getEl.addEventListener('scroll', handleScroll);
        }, 1000);

        return () => {
            getEl.removeEventListener('scroll', handleScroll)
        }
    }, []);
    
    

    if (isLoading) {
        return <Loader />;
    }

    if (data?.error) {
        return <ErrorPage />
    }
    

    let subcatsList = data?.cats?.filter(r => r?.parent?.val == params?.id);

	return (
		<>
            {isFetching && <Loader />}
            <Helmet>
                <title>{data?.cat?.name}</title>
                <meta name="description" content={data?.cat?.full} />
                <meta property="og:title" content={data?.cat?.name} />
                <meta property="og:description" content={data?.cat?.full} />
                <meta property="og:image" content={`${Config?.imgUrl}/${data?.cat?.img}`} />
            </Helmet>

			<Header title={true} /> 

            <nav className='mainWidth pathNames'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link to='/cat'>{t("all_products")}</Link>
                {data?.cat?.parent?.val && 
                <>
                    <MdArrowForwardIos />
                    <Link to={`/cat/${data?.cat?.parent?.val}`}>{data?.cat?.parent?.name}</Link>
                </>}
                <MdArrowForwardIos />
                <Link>{data?.cat?.name}</Link>
            </nav>

        

            <div className='mainWidth catPageBox'>

                <div className={`leftFilterBox ${openFilter ? "openFilter" : "static"}`} style={{flex: "none"}}>
                    <a onClick={() => setopenFilter(false)} className='closeFilter mobile_hide'><MdOutlineClose /></a>

                    <div className='filter homeTopProducts'>
                        <strong>{t("categories")}</strong>

                        <ListCats data={data?.cats} />
                    </div>
                    

                    <div className='filter homeTopProducts'>
                        <strong>{t("price_range")}</strong>

                        <Box className='sliderPriceBox'>
                            <Slider
                                getAriaLabel={() => 'Temperature range'}
                                value={price}
                                onChange={handleChange}
                                onChangeCommitted={() => dynamicFilter(price, 'price')}
                                valueLabelDisplay="off"
                                min={0}
                                max={maxPrice}
                                disableSwap

                            />

                            <span className='prcieViewBox'>{t("price")}: {priceFormat(price[0])} <b>{global.currency}</b> - {priceFormat(price[1])} <b>{global.currency}</b></span>
                        </Box>
                    </div>
                    
                    {Object.keys(data?.filter?.options)?.map((v, k) => {
                        let filterData = data?.filter?.options[v];
                                        
                        if (filterData?.type?.val == "numbers" || filterData?.type?.val == "colors") {
                            
                            return (
                                <div key={k} className='filter homeTopProducts'>
                                    <strong>{filterData?.name}</strong>

                                    {filterData?.type?.val == "colors" &&
                                        <div className='filterColorsBox'>
                                            <div>
                                                {filterData?.values?.map((v2, k2) => {
                                                    return (
                                                        <span key={k2} onClick={() => dynamicFilter(filter[v] == v2 ? false : v2, v)} style={{background:v2}} className={`colorInFilter ${filter[v] == v2 && "checked"}`}></span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    }

                                    {filterData?.type?.val == "numbers" &&
                                        <div className='filterColorsBox'>
                                            {filterData?.values?.map((v2, k2) => {
                                                return (
                                                    <span  key={k2} onClick={() => dynamicFilter(filter[v] == v2 ? false : v2, v)} className={`tagsinFilter ${filter[v] == v2 && "checked"}`}>{v2}</span>
                                                );
                                            })}
                                            
                                        </div>
                                    }
                                </div>
                            );
                        }

                    })}

               
                </div>

                <div className='homeTopProducts' style={{padding:0}}>

                    
                    {subcatsList?.length && params?.id ? <div style={{margin:0, }} className='homeCatsBox'>
                        
                        <ul className='catsMainBox'>
                            {subcatsList?.map((v, k) => {

                                let show = true;

                                if (show) {
                                    return (
                                        <Cats data={v} key={k} />
                                    );
                                }
                                
                            })}
                        </ul>

                    </div>: false}

                    <div className='filterBox'>
                        <span>{t("products_res")} <b>{data?.info?.count}</b> </span>

                        <div style={{display:"flex", gap:8, alignItems:"center"}}>

                            <a onClick={() => setopenFilter(d => !d)} className='filterBtn mobile_hide'><MdOutlineFilterList /></a>
                            <select onChange={(e) => sortLoad(e.target.value)} name='sort'>
                                <option selected={sort == 'date' ? true : false} value='date'>{t("sort_by_1")}</option>
                                {/* <option selected={sort == 'cats' ? true : false} value='cats'>{t("sort_by_5")}</option> */}
                                <option selected={sort == 'sold' ? true : false} value='sold'>{t("sort_by_2")}</option>
                                <option selected={sort == 'price' ? true : false} value='price'>{t("sort_by_3")}</option>
                                <option selected={sort == 'price2' ? true : false} value='price2'>{t("sort_by_4")}</option>
                            </select>
                        </div>
                    </div>


                    <div className='productsBox list5 catProductListBox' style={{marginTop:0, padding:20}}>
                        {products?.length ? products?.map((v, k) => {
                            return (
                                <Product data={v} key={k} /> 
                            );
                        }): <div className='noData'>{t("no_data")}</div>}


                    </div>

                    {siteInfo?.settings?.paging?.val && products?.length % 30 == 0 ? <button onClick={() => { loadMore();  }} className='btn loadMoreBtn'>{t("load_more")}..</button>: false}
        
                </div>

                
       

            </div>
            
            <Footer />
		</>
	)
}
